// Global, framework-agnostic click delegation for critical buttons.
// If React fails to bind an onClick, this still routes the action.

(function () {
  if (typeof window === "undefined") return;
  if (window.__FP_CLICK_DELEGATE__) return;
  window.__FP_CLICK_DELEGATE__ = true;

  // Actions are registered by the page (see App.jsx changes below)
  const getActions = () => (window.fpActions || {});

  // Prevent accidental <form> submissions when the intent is just a click.
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form?.dataset?.fpPreventSubmit === "true") {
      e.preventDefault();
    }
  }, { capture: true });

  // Delegate clicks from any element carrying data-action
  document.addEventListener("click", async (e) => {
    const el = e.target.closest?.("[data-action]");
    if (!el) return;
    const action = el.getAttribute("data-action");
    const fn = getActions()[action];
    if (typeof fn === "function") {
      try {
        e.preventDefault();
        await fn(e);
      } catch (err) {
        console.warn(`[fp click-delegate] action "${action}" failed:`, err);
        alert(`Action error: ${err?.message || err}`);
      }
    }
  });
})();
